import styled from '@emotion/styled';

export const Container = styled.div`
  border-top: solid 1px rgb(220, 220, 220);
  margin-top: 10px;
  padding: 10px 20px;
  display: grid;
  grid-template-columns: auto 200px;
  column-gap: 15px;

  button {
    display: 
  }
`

export const ButtonContainer = styled.div`
  display: block;
  padding: 10px;
`
